const getCssVariable = name =>
	getComputedStyle(document.documentElement)
		.getPropertyValue(name)
		.trim()

export const breakpoints = {
	IPHONE_SE: getCssVariable('--iphone_se'),
	PHONE_LARGE: getCssVariable('--phone_large'),
	MOBILE: getCssVariable('--mobile'),
	NOTEBOOK: getCssVariable('--notebook'),
	MOBILE_IFRAME_PLANALTO: getCssVariable('--mobile_iframe_planalto'),
	TABLET: getCssVariable('--tablet'),
	MEDIUM_SCREEN: getCssVariable('--medium_screen'),
	LAPTOP: getCssVariable('--laptop'),
	MOBILE_L: getCssVariable('--mobile_l'),
	MOBILE_M: getCssVariable('--mobile_m'),
	MOBILE_S: getCssVariable('--mobile_s'),
	LAPTOP_M: getCssVariable('--laptop_m'),
	LAPTOP_L: getCssVariable('--laptop_l')
}
